/* Copyright (c) 2018 Scaper */

import "./brand/theme.scss?inline";

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { StripeProvider } from "react-stripe-elements";
import { createApi } from "./api/api";
import { createAppStore } from "./app/store";
import { Scaper } from "./scaper";

import "./index.scss"

const store = createAppStore();
const api = createApi(store.dispatch, store.getState);

ReactDOM.render((
    <StripeProvider apiKey="pk_test_ktzkHmtqV0RUafCWPzTtK9t2">
        <Provider store={store}>
            <BrowserRouter>
                <Scaper api={api} />
            </BrowserRouter>
        </Provider>
    </StripeProvider>
), document.getElementById("react-app"));
